import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { GeneralService } from "src/app/services/general.service";
import { MerchantItems } from "src/app/models/items";
import { MockStoreService } from "src/app/services/mock-store.service";
import { Observable } from "rxjs";

@Component({
  selector: "app-view-content",
  templateUrl: "./view-content.component.html",
  styleUrls: ["./view-content.component.css"]
})
export class ViewContentComponent implements OnInit {
  @Output("closeUp") closeUp = new EventEmitter<any>();
  // analysis_option: 1;
  // category_id: "7";
  // created_at: "2020-06-03 12:42:57";
  // data_option: 1;
  // delivery_info: null;
  // description: "Original samsung phone";
  // discount: null;
  // fund_option: 0;
  // id: 217;
  // monthly_amount: "80000";
  // name: "Samsung s9";
  // no_of_months: "8";
  // no_of_months_upfront: "2";
  // price: "320000";
  // primary_picture: "https://res.cloudinary.com/africacodes-concepts-limited/image/upload/v1591188176/kctlbfbn235wapevdr3p.png";
  // secondary_picture: "https://res.cloudinary.com/africacodes-concepts-limited/image/upload/v1591188176/wqeuqqxtbwaqbtv4scjd.png";
  // slug: "9ec7HQaYQp48jDz";
  // tertiary_picture: "https://res.cloudinary.com/africacodes-concepts-limited/image/upload/v1591188177/y9d6prjvdisrt5995jw4.png";
  // updated_at: "2020-06-03 12:42:57";
  currentItemInView:
    | any
    | Partial<MerchantItems>
    | Observable<MerchantItems> = {};
  constructor(
    private generalservice: GeneralService,
    public mockstore: MockStoreService
  ) {
    //   primary_picture: string = "https://via.placeholder.com/43";
    // secondary_picture: string = "https://via.placeholder.com/43";
    // tertiary_picture: string = "https://via.placeholder.com/45";
    this.currentItemInView.primary_picture = "https://via.placeholder.com/43";
    this.currentItemInView.secondary_picture = "https://via.placeholder.com/43";
    this.currentItemInView.tertiary_picture = "https://via.placeholder.com/45";
  }

  ngOnInit(): void {
    this.currentItemInView = this.generalservice.singleMerchant$;
    // console.log(this.currentItemInView);
  }

  displayAppropriateDiscount(discount) {
    if (!discount || typeof discount == "object") return;
    return `${discount}% discount`;
  }

  // when the edit button is clicked, this function will fire;
  // sending up the addedItem that is being currently viewed;
  editCurrentItem() {
    this.closeUp.emit(this.mockstore.mostRecentlyAddedItem);
  }
}
